import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        loadComponent: () => import('./kudoshub-vs-zerobounce.component').then(m => m.KudoshubVsZerobounceComponent),
        data: {
          title: "#1 ZeroBounce Alternative - KudosHub",
          description:
            "Trusted by top teams, KudosHub delivers 99% accuracy, AI-powered scoring, and 2.5x better pricing than ZeroBounce. Compare now - start free with 3,000 validations.",
          keywords: "zerobounce alternative, better than zerobounce, 99% accuracy, eliminate invalid, spam traps, abusive, catch-all, disposable, toxic and role-based emails",
          ogTitle: "#1 ZeroBounce Alternative - KudosHub",
          ogDesc:
            "Trusted by top teams, KudosHub delivers 99% accuracy, AI-powered scoring, and 2.5x better pricing than ZeroBounce. Compare now - start free with 3,000 validations.",
          ogImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
          ogUrl: "https://kudoshub.com/zerobounce-alternative",
          twitterTitle: "#1 ZeroBounce Alternative - KudosHub",
          twitterDesc:
            "Trusted by top teams, KudosHub delivers 99% accuracy, AI-powered scoring, and 2.5x better pricing than ZeroBounce. Compare now - start free with 3,000 validations.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
          dateModified: "2025-09-04T12:00:00+05:30"
        },
      },
    ],
  },
];
